import * as React from 'react';
import { UitkText } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { PropertyRateCalendar } from 'src/common/__generated__/api/types';

export interface RateCalendarFooterProps {
  legends: PropertyRateCalendar.Legend[]
}

export function RateCalendarFooter(props: RateCalendarFooterProps) {
    return (
      <UitkLayoutFlex>
        {
          props.legends.map((legend, index) => {
            const trendLowerCase = legend.trend.toLowerCase() as 'positive' | 'negative';

            return (
              <>
                <UitkLayoutFlexItem key={`legend-icon-${index}`}>
                  <UitkSpacing className={`rate-calendar-footer ${trendLowerCase}`}>
                    <UitkIcon name={legend.symbol} theme={trendLowerCase} size={UitkIconSize.MEDIUM} />
                  </UitkSpacing>
                </UitkLayoutFlexItem>
                <UitkLayoutFlexItem key={`legend-label-${index}`}>
                  <UitkSpacing padding={{ blockstart: 'one', inlinestart: 'one', inlineend: 'three' }}>
                    <UitkText weight={'bold'}>{legend.label}</UitkText>
                  </UitkSpacing>
                </UitkLayoutFlexItem>
              </>
            )
          })
        }
      </UitkLayoutFlex>
    );
}
